import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/settings/unit_types";
const apiDropDownEndpoint =
	API_BASE_URL_ENV() + "/admin/settings/dropdown/UnitType?status=1";

export default class extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	getFooterData = () => {
		return http.get(`${apiDropDownEndpoint}&footer=1`);
	};
	getDropDown = () => {
		return http.get(apiDropDownEndpoint);
	};

	getUnitTypesDropDown = (ids) => {
		return http.get(
			API_BASE_URL_ENV() +
				`/admin/settings/dropdown/UnitType?compounds=${ids}&status=1`
		);
	};
}
